// Schnell-Loggen auf der Kontakt-Aktivität (Logik wie bisher in KontaktAktivitaet):
// Notiz → kontakt_notizen (Betreff + optionale Notiz), Anruf/Mail/Meeting → kontakt_aktivitaeten.
import { logAktivitaet, speichereNotiz, type LogEingabe } from './api';
import type { KontaktQuelle } from './types';

export type SchnellLogTyp = 'anruf' | 'mail' | 'meeting' | 'notiz';
export type Richtung = 'eingehend' | 'ausgehend';

export interface SchnellLogFelder {
  typ: SchnellLogTyp;
  betreff: string;
  notiz: string;
  richtung: Richtung;
  /** Minuten als Eingabetext */
  dauer: string;
}

export type SchnellLogZiel = { art: 'notiz'; text: string } | { art: 'log'; eingabe: LogEingabe };

/** null, wenn der Betreff leer ist (Speichern gesperrt). */
export function baueSchnellLog(f: SchnellLogFelder): SchnellLogZiel | null {
  const b = f.betreff.trim();
  if (!b) return null;
  if (f.typ === 'notiz') return { art: 'notiz', text: b + (f.notiz.trim() ? '\n' + f.notiz.trim() : '') };
  return {
    art: 'log',
    eingabe: {
      typ: f.typ,
      betreff: b,
      notiz: f.notiz.trim() || null,
      richtung: f.typ === 'anruf' || f.typ === 'mail' ? f.richtung : null,
      dauer_minuten: (f.typ === 'anruf' || f.typ === 'meeting') && f.dauer ? Number(f.dauer) : null,
    },
  };
}

export async function speichereSchnellLog(quelle: KontaktQuelle, id: string, ziel: SchnellLogZiel): Promise<void> {
  if (ziel.art === 'notiz') await speichereNotiz(quelle, id, ziel.text);
  else await logAktivitaet(quelle, id, ziel.eingabe);
}

/** Platzhalter des Betreff-Felds wie bisher. */
export function betreffPlatzhalter(typ: SchnellLogTyp): string {
  return typ === 'meeting' ? 'Betreff des Meetings …' : typ === 'anruf' ? 'Worum ging es? …' : 'Betreff …';
}
